module.exports = __webpack_public_path__ + "img/jb1.6383de4.png";